import { render, staticRenderFns } from "./Password2.vue?vue&type=template&id=70ca41bb&scoped=true&"
import script from "./Password2.vue?vue&type=script&lang=js&"
export * from "./Password2.vue?vue&type=script&lang=js&"
import style0 from "./Password2.vue?vue&type=style&index=0&id=70ca41bb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ca41bb",
  null
  
)

export default component.exports